// extracted by mini-css-extract-plugin
export var animationContainer = "_ii-0";
export var asteriskIcon = "_ii-8";
export var conversationLeftSection = "_ii-4";
export var conversationListItem = "_ii-3";
export var conversationMiddleSection = "_ii-5";
export var conversationRightSection = "_ii-6";
export var detailsContent = "_ii-1";
export var listContainer = "_ii-7";
export var modalContent = "_ii-2";